import dispatcher from "../dispatcher";
import { paymentModeConstant } from "../constants/constants";
import rq from "../components/utility/rq.js";

export function createPaymentMode(payMode) {
    rq.post("/api/v1/paymentmode", payMode).then((data) => {
        payMode.payModeId = data[0].lastId;
        dispatcher.dispatch({ type: paymentModeConstant.PAYMENTMODE_CREATED, payMode });
    }).catch((data) => {
        dispatcher.dispatch({ type: paymentModeConstant.PAYMENTMODE_CREATION_FAILED, msg: `creating payment Mode failed ! ${data.responseText}` });
    });
}

export function fetchAllPaymentMode() {
    rq.getJsonData("/api/v1/paymentmode").then((data) => {
        dispatcher.dispatch({ type: paymentModeConstant.FETCHED_ALL_PAYMENTMODE, data });
    }).catch((data) => {
        dispatcher.dispatch({ type: paymentModeConstant.PAYMENTMODE_FETCH_FAILED, msg: "Fetching shift failed ! " });
    });
}



// WEBPACK FOOTER //
// ./src/jsx/actions/payment-mode-action.jsx